import React, { useEffect, useRef, useState } from "react";
import styles from "./GameTable.module.css";
import gameAssets from "@themed-assets";
import CommunityCards from "../CommunityCards/CommunityCards";
import PlayersLayout from "../PlayersLayout/PlayersLayout";
import {
  hidePlayerPositions,
  updateGameTableBoundingRect,
  updatePositionsArranged,
} from "@/Poker/redux/slices/gameTableSlice";
import { useDispatch } from "react-redux";
import TotalPotAmount from "../TotalPotAmount/TotalPotAmount";
import PotAmountContainer from "../PotAmount/PotAmountContainer";
// import WinnerHandStrength from "../WinnerHandStrength/WinnerHandStrength";
import { WinnerHandStrength } from '@themed-components';
// import PlayerStats from "../PlayerStats/PlayerStats";
import { PlayerStats } from '@themed-components';

export default function GameTable({ tempTableId }) {
  const dispatch = useDispatch();
  const [gameTableLoaded, setGameTableLoaded] = useState(false);
  const gameTableRenderTimeout = useRef(null);
  const gameTableRef = useRef(null);

  const updateBoundingClientRect = () => {
    setGameTableLoaded(false);
    dispatch(hidePlayerPositions({ tempTableId: tempTableId }));
    try {
      let boundingClientRectangle =
        gameTableRef?.current?.getBoundingClientRect();
      if (
        Math.abs(boundingClientRectangle.top - boundingClientRectangle.bottom) >
          100 &&
        boundingClientRectangle
      ) {
        clearTimeout(gameTableRenderTimeout.current);
        gameTableRenderTimeout.current = setTimeout(() => {
          dispatch(
            updateGameTableBoundingRect({
              tempTableId: tempTableId,
              positions: JSON.stringify(
                gameTableRef?.current?.getBoundingClientRect()
              ),
              horizontalOffset:
                (window.innerWidth -
                  gameTableRef?.current?.getBoundingClientRect().width) /
                2,
              verticalOffset:
                (window.innerHeight -
                  gameTableRef?.current?.getBoundingClientRect().height) /
                2,
            })
          );
          dispatch(updatePositionsArranged({ tempTableId: tempTableId }));
          setGameTableLoaded(true);
        }, 750);
      }
    } catch (err) {
      console.log("Error in catching bounding client rect", err);
    }
  };

  useEffect(() => {
    updateBoundingClientRect();
  }, [gameTableRef]);

  return (
    <div className={styles.perspectiveGameTableContainer}>
      {/* Game Table Image */}
      <img
        onLoadStart={() => setGameTableLoaded(false)}
        onLoad={() => updateBoundingClientRect()}
        ref={gameTableRef}
        className={styles.perspectiveGameTableImage}
        src={gameAssets.gameTable1}
        alt='Game Table'
      />
      {gameTableLoaded ? (
        <>
          {/* Game Table Player Layout */}
          <PlayersLayout
            gameTableLoaded={gameTableLoaded}
            tempTableId={tempTableId}
          />
          {/* Pot Amount */}
          <TotalPotAmount tempTableId={tempTableId} />
          {/* Game Table Community Cards */}
          <CommunityCards tempTableId={tempTableId} />
          {/* Game Pots */}
          <PotAmountContainer tempTableId={tempTableId} />
          {/* Winner Hand Strength */}
          <WinnerHandStrength tempTableId={tempTableId} />
          <PlayerStats tempTableId={tempTableId} />
        </>
      ) : null}
    </div>
  );
}
